import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ChatClientService } from 'stream-chat-angular';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { ICompany, IUser } from '../../../../../assets/types/dtoTypes';
import { Observable } from 'rxjs';

@Injectable( {
  providedIn: 'root',
} )
export class StreamChatService {
  private chatService = inject(ChatClientService);
  private authService = inject(AuthenticationService);
  private http = inject(HttpClient);


  private url = `${environment.apiUrl}/chats/token`;

  private userUrl = `${environment.apiUrl}/users`;

  private comapnyUrl = `${environment.apiUrl}/companies`;


  constructor() {
  }

  createChat( id: string ): Promise<{ token: string }> {
    return this.http.post<{ token: string }>( this.url, id ).toPromise();
  }

  getUser( id: string ): Promise<IUser> {
    const url = `${this.userUrl}/${id}`;
    return this.http.get<IUser>( url ).toPromise();
  }

  public getCompanyData( id: string ): Observable<ICompany> {
    const url = `${this.comapnyUrl}/${id}`;
    return this.http.get<ICompany>( url );
  }

}
